import API from './API.js'
import axios from 'axios'

export default class QuranPrograms extends API {
  constructor() {
    super('quranProgram')
  }
  // addTeacherAsSupervisor
  async MakeSupervisor(params) {
    const response = await axios.post(`/storeProgram/addTeacherAsSupervisor`, params)
    return response.data
  }
  //assignTeacher
  async AssignTeacher(id, params) {
    const response = await axios.post(`storeProgram/assignTeacher/${id}`, params)
    return response.data
  }
  // /quranProgram/schedule
  async Addschedule(params) {
    const response = await axios.post(`/quranProgram/schedule`, params)
    return response.data
  }
  //scedule/students/assign
  async StudentAssign(params) {
    const response = await axios.post(`/scedule/students/assign`, params)
    return response.data
  }
  //joinFreeProgramRequest
  async Join(params) {
    const response = await axios.post(`/quran_program/joinFree`, params)
    return response.data
  }
  ///quranProgram/myProgram
  async MyProgram(params) {
    const response = await axios.get(`/quran-program-dates/myProgram`, { params })
    return response.data
  }
  async ProgramTeacher(params) {
    const response = await axios.get(`/quran-program-dates/program-teacher`, { params })
    return response.data
  }
  async ArchiveStudent(studentId) {
    const response = await axios.post(`/quranProgram/archiveStudent/${studentId}`)
    return response.data
  }

  ReadingType() {

    return [{ "id": 1, "name": "نافع بن عبد الرحمن بن أبي نعيم المدني" },
    { "id": 2, "name": "عبد الله بن كثير الداري المكي" },
    { "id": 3, "name": "أبو عمرو بن العلاء البصري" },
    { "id": 4, "name": "عبد الله بن عامر اليحصبي الشامي" },
    { "id": 5, "name": "عاصم بن أبي النجود الأسدي الكوفي" },
    { "id": 6, "name": "حمزة بن حبيب الزيات الكوفي" },
    { "id": 7, "name": "أبو الحسن علي بن حمزة الكسائي النحوي الكوفي" },
    { "id": 8, "name": "أبو جعفر يزيد بن القعقاع المدني" },
    { "id": 9, "name": "يعقوب بن اسحاق الحضرمي الكوفي" },
    { "id": 10, "name": "خلف بن هشام" }]
  }
}
